import type {ActionReducerMapBuilder} from '@reduxjs/toolkit';
import {
  initEmailMarketingCampaignPerformance,
  removeInvalidEmailsForCampaign,
  removeInvalidEmailsForMailingList,
} from './email-marketing-performance-thunk';
import {LOADING_STATES} from '@Libraries/email-marketing-campaigns-library';
import {getFirstSelectedItemId} from './email-marketing-campaign-performance-library';
import type {EmailMarketingCampaignPerformanceState} from './email-marketing-campaign-performance.types';

export const emailMarketingCampaignPerformanceExtraReducers = (builder: ActionReducerMapBuilder<EmailMarketingCampaignPerformanceState>): void => {
  builder.addCase(initEmailMarketingCampaignPerformance.pending, (state) => {
    state.performanceLoadingState = LOADING_STATES.LOADING;
  });

  builder.addCase(initEmailMarketingCampaignPerformance.fulfilled, (state, {payload}) => {
    state.campaigns = payload.campaigns;
    state.campaignsWithMetricsAvailable = payload.campaignsWithMetricsAvailable;
    state.campaignsWithMetricsNotAvailable = payload.campaignsWithMetricsNotAvailable;
    state.campaignsWithMetricsCollecting = payload.campaignsWithMetricsCollecting;
    state.campaignMetrics = payload.campaignMetrics;
    state.mailingLists = payload.mailingLists;
    state.mailingListsWithAvailableMetrics = payload.mailingListsWithAvailableMetrics;
    state.mailingListsWithMetricsNotAvailable = payload.mailingListsWithMetricsNotAvailable;
    state.mailingListsWithMetricsCollecting = payload.mailingListsWithMetricsCollecting;
    state.mailingListMetrics = payload.mailingListMetrics;
    state.itemType = payload.itemType;
    state.selectedItemIds = payload.selectedItemIds.map((id) => String(id));
    state.isNoCampaignCreated = payload.isNoCampaignCreated;
    state.isNoCampaignPublished = payload.isNoCampaignPublished;
    state.isCollectingData = payload.isCollectingData;
    state.isNoMailingListCreated = payload.isNoMailingListCreated;
    state.isNotCollectingData = payload.isNotCollectingData;
    state.performanceLoadingState = LOADING_STATES.LOADED;
  });

  builder.addCase(removeInvalidEmailsForCampaign.pending, (state) => {
    state.performanceLoadingState = LOADING_STATES.LOADING;
  });

  builder.addCase(removeInvalidEmailsForCampaign.fulfilled, (state, {meta}) => {
    state.performanceLoadingState = LOADING_STATES.LOADED;
    const firstId = getFirstSelectedItemId(state.selectedItemIds);
    if (!firstId) {
      return;
    }
    meta.arg.emails.forEach((email) => {
      state.campaignMetrics[firstId].details[email].isDeleted = true;
    });
  });

  builder.addCase(removeInvalidEmailsForMailingList.pending, (state) => {
    state.performanceLoadingState = LOADING_STATES.LOADING;
  });

  builder.addCase(removeInvalidEmailsForMailingList.fulfilled, (state, {meta}) => {
    state.performanceLoadingState = LOADING_STATES.LOADED;
    const firstId = getFirstSelectedItemId(state.selectedItemIds);
    if (!firstId) {
      return;
    }
    meta.arg.emails.forEach((email) => {
      state.mailingListMetrics[firstId].insights[email].isDeleted = true;
    });
  });
};
